import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 5px 0;
  & > div {
    margin-top: 15px;

    & > ol {
      margin-bottom: 10px;

      &  > li {
        margin-bottom: 0.5em;
      }
    }
  }
`

export const A = styled.a`
  margin-bottom: 5px;
`

export const LiteratureWrapper = styled.div`
    font-size: 0.82em;
    line-height: 1.3em;

    p {
        margin-bottom: 0.5em;
    }
`